import React, {useContext, useEffect, useRef, useState} from 'react';
import Nav from "../../components/ui/nav/nav";

import style from "./orders.module.scss"

import {Context} from "../../index";
import {observer} from "mobx-react-lite";
import OrderPopup from "../../components/popups/orderPopup";
import OrderItem from "../../components/ui/orderItem/orderItem";
import {io} from "socket.io-client";
import useSound from "use-sound";
import newOrderSound from "../../sounds/newOrder.mp3";



const getLocalDateString = (date = new Date()) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const Orders = observer(() => {
    const [currentTab, setCurrenTab] = useState(0)
    const {orders} = useContext(Context)
    const [selectDate, setSelectDate] = useState(getLocalDateString())
    const [ordersData, setOrdersData] = useState([])
    const [popupData, setPopupData] = useState({visible: false, data: {}})
    const [play] = useSound(newOrderSound);

    const selectDateRef = useRef(selectDate);
    useEffect(() => {
        selectDateRef.current = selectDate;
    }, [selectDate]);

    const tabsBtn = [
        {title: "Все", background: "#D2D2D2", status: "Все"},
        {title: "Новые", background: "#C3EABD", status: "Новый", color: "#1DCC00"},
        {title: "В работе", background: "#EAE5BD", status: "В работе", color: "#E1CE39"},
        {title: "Завершенные", background: "#D2D2D2", status: "Завершен", color: "#B0B0B0"},
        {title: "Отменен", background: "#E39797", status: "Отменен", color: "#E39797"}
    ]

    const playRef = useRef(play);
    useEffect(() => {
        playRef.current = play;
    }, [play]);

    useEffect(() => {
        const fetch = async () => {
            await orders.getAll(selectDate)
        }
        fetch()
    }, [selectDate]);

    useEffect(() => {
        const socket = io("https://tailao.ru");
	        const handleNewOrder = async () => {
                try {
                        playRef.current()
                        await orders.getAll(selectDateRef.current)
                } catch (e) {
                        console.log(e)
                }
        };
        socket.on("newOrder", handleNewOrder);

        return () => {
            socket.off("newOrder", handleNewOrder);
            socket.disconnect();
        };
    }, []);

    useEffect(() => {
        if (currentTab !== 0) {
            const filterOrders = orders?.orders?.orders?.filter(order => order?.status === tabsBtn[currentTab].status)
            setOrdersData(filterOrders)
        } else {
            setOrdersData(orders.orders.orders)
        }
    }, [currentTab, orders.orders.orders]);


    return (
        <div className="page">
            <div className="page_container">
                <div className={style.block}>
                    <Nav title="Заявки">
                        <div className={style.body}>
                            <div className={style.row}>
                                <div className={style.tabs}>
                                    {tabsBtn.map((tab, index) =>
                                        <button
                                            key={tab.title}
                                            onClick={e => setCurrenTab(index)}
                                            className={currentTab === index ? [style.tabBtn, style.tabBtnActive].join(" ") : style.tabBtn}
                                            style={{"--color": `${tab.background}`}}
                                        >
                                            {tab.title}
                                        </button>
                                    )}
                                </div>
                                <div className={style.today}>
                                    <input value={selectDate} type="date" onChange={e => setSelectDate(e.target.value)} className={style.dateInput}/>
                                </div>
                            </div>

                            <div className={style.table}>
                                <div className={style.tableHeader}>
                                    <div>Заказ</div>
                                    <div>Статус</div>
                                    <div>Имя</div>
                                    <div>Адрес</div>
                                    <div>Телефон</div>
                                    <div>Тип</div>
                                    <div>Сумма</div>
                                </div>
                                <div className={style.tableBody}>
                                    {ordersData?.length > 0 && ordersData.map(item =>
                                        <OrderItem key={item?.id} order={item} setPopupData={setPopupData} popupData={popupData} tabsBtn={tabsBtn}/>
                                    )}
                                </div>
                                <div className={style.tableFooter}>
                                    <div>Всего: {ordersData?.length}</div>
                                    <div>Сумма: {orders.orders.cost}р</div>
                                </div>
                            </div>
                        </div>
                    </Nav>
                </div>
                <OrderPopup popupData={popupData} setPopupData={setPopupData} tabsBtn={tabsBtn}/>
            </div>
        </div>
    );
});

export default Orders;
